<template>
    <div ref="textBoxDialog" id="textBoxDialog" v-show="textBoxDialogShow">
        <div id="textBoxBarTool">
            <div ref="fontSizeFrame" id="fontSizeFrame">
                <img class="toolImg" src="../assets/other_tools/common/icon_A.svg">
                <select ref="fontSizeSelect" id="fontSizeSelect" v-on:input="textSizeValueChange">
                </select>
            </div>

            <div>
                <img class="setImgSize20" src="../assets/other_tools/common/icon_分隔線.svg">
            </div>

            <div ref="fontColorFrame" id="fontColorFrame" v-on:click="isFontColorSelectShow(!this.fontSelectColorShow)">
                <div ref="fontColorBtn" id="fontColorBtn">
                    <img src="../assets/other_tools/common/icon_A.svg">
                    <canvas id="fontColorView"></canvas>
                </div>
                <div>
                    <img class="setImgSize20" src="../assets/other_tools/common/icon_箭頭.svg">
                </div>
            </div>

            <div>
                <img class="setImgSize20" src="../assets/other_tools/common/icon_分隔線.svg">
            </div>

            <div>
                <img ref="btnBoldEl" id="btnBoldEl" class="toolImg" src="../assets/other_tools/common/icon_B.svg"
                    v-on:click="clickButtonBoldEl">
            </div>

            <div>
                <img ref="btnItalicEl" id="btnItalicEl" class="toolImg" src="../assets/other_tools/common/icon_I.svg"
                    v-on:click="clickButtonItalicEl">
            </div>

            <div>
                <img ref="btnUnderlineEl" id="btnUnderlineEl" class="toolImg" src="../assets/other_tools/common/icon_U.svg"
                    v-on:click="clickButtonUnderlineEl">
            </div>

            <div>
                <img class="setImgSize20" src="../assets/other_tools/common/icon_分隔線.svg">
            </div>

            <div ref="selectBgColorBtn" id="selectBgColorBtn" v-on:click="isFrameSelectColorShow('BG')">
                <div>
                    <img class="toolImg" src="../assets/other_tools/common/icon_油漆桶.svg">
                </div>
                <div>
                    <img class="setImgSize20" src="../assets/other_tools/common/icon_箭頭.svg">
                </div>
            </div>

            <div>
                <img class="setImgSize20" src="../assets/other_tools/common/icon_分隔線.svg">
            </div>

            <div ref="selectFrameColorBtn" id="selectFrameColorBtn" v-on:click="isFrameSelectColorShow('FRAME')">
                <div>
                    <img class="setImgSize20" src="../assets/other_tools/common/icon_文字框顏色.svg">
                </div>

                <div>
                    <img class="setImgSize20" src="../assets/other_tools/common/icon_箭頭.svg">
                </div>
            </div>

            <div>
                <img class="setImgSize20" src="../assets/other_tools/common/icon_分隔線.svg">
            </div>

            <div>
                <img ref="btnDelTextBoxEl" id="btnDelTextBoxEl" v-on:click="clickBtnDelTextBoxEl" class="setImgSize20"
                    src="../assets/other_tools/common/icon_垃圾桶.svg">
            </div>

        </div>
    </div>

    <div ref="directionDialog" id="directionDialog" v-show="directionBarShow">
        <div ref="directionBar" id="directionBar">
            <div>
                <button ref="buttonHorizontalEl" id="buttonHorizontalEl"
                    v-on:click="(e) => { clickDirection(DEFINE.TEXT_DIRECTION.VERTICAL); }">直書</button>
            </div>
            <div>
                <img src="../assets/other_tools/common/icon_分隔線.svg">
            </div>
            <div>
                <button ref="buttonVerticalEl" id="buttonVerticalEl"
                    v-on:click="(e) => { clickDirection(DEFINE.TEXT_DIRECTION.HORIZONTAL); }">橫書</button>
            </div>
        </div>
    </div>

    <div ref="fontSelectColor" id="fontSelectColor" v-show="fontSelectColorShow">
        <div>
            <div>
                <img src="../assets/other_tools/text_box/FF0000.svg" alt="" v-on:click="textColorElValueChange('#FF0000')">
            </div>
            <div>
                <img src="../assets/other_tools/text_box/00FF00.svg" alt="" v-on:click="textColorElValueChange('#00FF00')">
            </div>
            <div>
                <img src="../assets/other_tools/text_box/FF00FF.svg" alt="" v-on:click="textColorElValueChange('#FF00FF')">
            </div>
            <div>
                <img src="../assets/other_tools/text_box/000000.svg" alt="" v-on:click="textColorElValueChange('#000000')">
            </div>
        </div>

        <div>
            <div>
                <img src="../assets/other_tools/text_box/990000.svg" alt="" v-on:click="textColorElValueChange('#990000')">
            </div>
            <div>
                <img src="../assets/other_tools/text_box/009900.svg" alt="" v-on:click="textColorElValueChange('#009900')">
            </div>
            <div>
                <img src="../assets/other_tools/text_box/6600FF.svg" alt="" v-on:click="textColorElValueChange('#6600FF')">
            </div>
            <div>
                <img src="../assets/other_tools/text_box/545454.svg" alt="" v-on:click="textColorElValueChange('#545454')">
            </div>
        </div>

        <div>
            <div>
                <img src="../assets/other_tools/text_box/FFFF00.svg" alt="" v-on:click="textColorElValueChange('#FFFF00')">
            </div>
            <div>
                <img src="../assets/other_tools/text_box/996600.svg" alt="" v-on:click="textColorElValueChange('#996600')">
            </div>
            <div>
                <img src="../assets/other_tools/text_box/0000FF.svg" alt="" v-on:click="textColorElValueChange('#0000FF')">
            </div>
            <div>
                <img src="../assets/other_tools/text_box/A8A8A8.svg" alt="" v-on:click="textColorElValueChange('#A8A8A8')">
            </div>
        </div>

        <div>
            <div>
                <img src="../assets/other_tools/text_box/FF6600.svg" alt="" v-on:click="textColorElValueChange('#FF6600')">
            </div>
            <div>
                <img src="../assets/other_tools/text_box/009999.svg" alt="" v-on:click="textColorElValueChange('#009999')">
            </div>
            <div>
                <img src="../assets/other_tools/text_box/00FFFF.svg" alt="" v-on:click="textColorElValueChange('#00FFFF')">
            </div>
            <div>
                <img src="../assets/other_tools/text_box/FFFFFF.svg" alt="" v-on:click="textColorElValueChange('#FFFFFF')">
            </div>
        </div>
    </div>

    <div ref="FrameSelectColor" id="FrameSelectColor" v-show="FrameSelectColorShow">
        <div>
            <div>
                <img src="../assets/other_tools/text_box/色塊_non.svg" alt="" v-on:click="checkFrameType('transparent')">
            </div>
            <div>
                <img src="../assets/other_tools/text_box/FFFFFF.svg" alt="" v-on:click="checkFrameType('#FFFFFF')">
            </div>
            <div>
                <img src="../assets/other_tools/text_box/A8A8A8.svg" alt="" v-on:click="checkFrameType('#A8A8A8')">
            </div>
            <div>
                <img src="../assets/other_tools/text_box/545454.svg" alt="" v-on:click="checkFrameType('#545454')">
            </div>
            <div>
                <img src="../assets/other_tools/text_box/000000.svg" alt="" v-on:click="checkFrameType('#000000')">
            </div>
        </div>

        <div>
            <div>
                <img src="../assets/other_tools/text_box/00FFFF.svg" alt="" v-on:click="checkFrameType('#00FFFF')">
            </div>
            <div>
                <img src="../assets/other_tools/text_box/00FF00.svg" alt="" v-on:click="checkFrameType('#00FF00')">
            </div>
            <div>
                <img src="../assets/other_tools/text_box/FFFF00.svg" alt="" v-on:click="checkFrameType('#FFFF00')">
            </div>
            <div>
                <img src="../assets/other_tools/text_box/FCD5B4.svg" alt="" v-on:click="checkFrameType('#FCD5B4')">
            </div>
            <div>
                <img src="../assets/other_tools/text_box/FF99FF.svg" alt="" v-on:click="checkFrameType('#FF99FF')">
            </div>
        </div>
    </div>
    <ConfirmDialog ref="confirmDialog" />
</template>

<script>
import { useFavicon } from "@vueuse/core";
import ConfirmDialog from "../components/dialogs/ConfirmDialog.vue";
import DEFINE from "../js/painter/define";
import EventBus from '../js/event_bus';
import { windowContentScaleX, windowContentScaleY } from '../js/common/content_scale';
import { store } from '../store';
import { focusStore } from '../js/store/nowFocusStore';


const FONT_SIZE_MIN = 8;
const FONT_SIZE_MAX = 100;

const TXT_BOX_TEXT_COLOR =
{
    0: "transparent",
    1: "#FF0000",
    2: "#990000",
    3: "#FFFF00",
    4: "#FF6600",
    5: "#00FF00",
    6: "#009900",
    7: "#996600",
    8: "#009999",
    9: "#FF00FF",
    10: "#6600FF",
    11: "#0000FF",
    12: "#00FFFF",
    13: "#000000",
    14: "#545454",
    15: "#A8A8A8",
    16: "#FFFFFF"
};

// const COLOR_MIN = 0;
// const COLOR_MAX = Object.keys(TXT_BOX_TEXT_COLOR).length;

const HEIGHT = 40;
const SPACE = 10;

export default {
    components: { ConfirmDialog },
    data() {
        return {

            textBoxDialogShow: false,
            directionBarShow: false,
            fontSelectColorShow: false,
            FrameSelectColorShow: false,
            curSelectType: null,

            //=========================

            textSize: 12,
            textColor: "#FFFFFF",
            textBoxColor: "transparent",
            textBoxBorderColor: "transparent",
            curTextBoxBar: null,
            curTextBoxSelectBar: null,

            //==========================
            DEFINE
        };
    },
    methods: {
        textSizeValueChange() {
            this.textSize = this.$refs.fontSizeSelect.value;
            this.curTextBoxBar.updateTextSize(this.textSize);
        },
        textColorElValueChange(color) {
            this.textColor = color;
            this.curTextBoxBar.updateTextColor(this.textColor);
        },
        clickButtonBoldEl() {
            console.log("updateBold");
            this.curTextBoxBar.updateBold();
        },
        clickButtonItalicEl() {
            this.curTextBoxBar.updateItalic();
        },
        clickButtonUnderlineEl() {
            this.curTextBoxBar.updateUnderline();
        },
        checkFrameType(color) {
            if (this.curSelectType == "BG") {
                this.textBoxColorElValueChange(color);

            } else if (this.curSelectType == "FRAME") {

                this.textBoxBorderColorElValueChange(color);
            } else {
                console.error("selectType 錯誤")
            }

        },
        textBoxColorElValueChange(color) {
            this.textBoxColor = color;
            //this.textBoxColor = this.$refs.textBoxColorEl.value;
            this.curTextBoxBar.updateTextBoxColor(this.textBoxColor);
        },
        textBoxBorderColorElValueChange(color) {
            this.textBoxBorderColor = color
            //this.textBoxBorderColor = this.$refs.textBoxBorderColorEl.value;
            this.curTextBoxBar.updateTextBoxBorderColor(this.textBoxBorderColor);
        },
        clickBtnDelTextBoxEl() {

            this.$refs.confirmDialog.showDialog("警告", "確定要刪除嗎？", () => {
                this.curTextBoxBar.delTextBox();
                this.isTextBoxBarShow(false);
            }, () => { }, "刪除");
        },
        clickDirection(direction) {
            this.isDirectionBarShow(false);
            this.curTextBoxSelectBar.optionsClick(direction);
            this.curTextBoxSelectBar = null;
        },
        updateTextBox(newTextBoxColor, newTextBoxBorderColor) {
            this.textBoxColor = newTextBoxColor;
            this.$refs.textBoxColorEl.value = this.textBoxColor;
            this.textBoxBorderColor = newTextBoxBorderColor;
            this.$refs.textBoxBorderColorEl.value = this.textBoxBorderColor;
        },
        setTextBoxBarPoint(newTextBoxBar, newX, newY) {
            this.curTextBoxBar = newTextBoxBar;

            let newLeft = 0;
            let newTop = 0;

            switch (focusStore.getNowPageItemControl().type) {
                case "mainPage":
                    newLeft = parseFloat(newX);
                    newTop = parseFloat(newY - SPACE - HEIGHT);
                    break;
                case "whiteBoard":
                    newLeft = parseFloat(newX);
                    newTop = parseFloat(newY - SPACE - HEIGHT);
                    break;
                case "afileMovie":
                    console.error("電子白板不可使用文字方塊");
                    break;
                case "afile":
                case "afileImage":
                    let targetWindow = focusStore.focusBookPage.$refs.aFileWindow;

                    newLeft = parseFloat(newX * (targetWindow.width / store.baseSize.width) + targetWindow.left);
                    newTop = parseFloat((newY * (targetWindow.height / store.baseSize.height) + targetWindow.top) - SPACE - HEIGHT);
                    break;
                case "graphicBoard":
                    const contentCanvas = focusStore.focusBookPage.$refs.contentCanvas;
                    newLeft = parseFloat(newX);
                    newTop = parseFloat(newY - SPACE - HEIGHT + contentCanvas.offsetTop);
                    break;
            }

            let position = this.limitToView(this.$refs.textBoxDialog, { x: newLeft, y: newTop });

            this.$refs.textBoxDialog.style.left = position.x + "px";
            this.$refs.textBoxDialog.style.top = position.y + "px";
        },
        setDirectionBarPoint(newTextBoxSelectBar, newX, newY) {
            const self = this;

            EventBus.getInstance().pointerdownCallback.push(this.isDirectionBarShow.bind(this, false));
            this.curTextBoxSelectBar = newTextBoxSelectBar;
            const directionDialog = this.$refs.directionDialog;
            const marginTop = 4;
            // 先移出視窗外在移動到正確位置
            directionDialog.style.left = -999 + "px"
            directionDialog.style.top = -999 + "px"
            setTimeout(() => {
                let newLeft = parseFloat(newX / (windowContentScaleX.value / windowContentScaleY.value));
                let newTop = parseFloat(newY - directionDialog.offsetHeight - marginTop);

                let position = this.limitToView(directionDialog, { x: newLeft, y: newTop });

                directionDialog.style.left = position.x + "px"
                directionDialog.style.top = position.y + "px"
            });
        },
        setSelectTextSize(size) {
            document.getElementById(size).selected = true;
        },
        isTextBoxBarShow(visible) {
            console.log("visible:", visible);
            this.textBoxDialogShow = visible;
            this.fontSelectColorShow = false;
            this.FrameSelectColorShow = false;
        },
        isDirectionBarShow(visible) {
            this.directionBarShow = visible;
        },
        isFontColorSelectShow(visible) {
            this.fontSelectColorShow = visible;
            this.FrameSelectColorShow = false;

            let textBoxRect = this.$refs.textBoxDialog.getBoundingClientRect();

            let newLeft = parseFloat(this.$refs.textBoxDialog.style.left) + this.$refs.fontColorFrame.offsetLeft;
            let newTop = parseFloat(this.$refs.textBoxDialog.style.top) + textBoxRect.height / windowContentScaleY.value;

            let position = this.limitToView(this.$refs.fontSelectColor, { x: newLeft, y: newTop });

            this.$refs.fontSelectColor.style.left = position.x + "px";
            this.$refs.fontSelectColor.style.top = position.y + "px";
        },
        isFrameSelectColorShow(selectType) {

            this.fontSelectColorShow = false;

            if (this.FrameSelectColorShow == true && this.curSelectType == selectType) {
                this.FrameSelectColorShow = false;
                this.curSelectType = null;
                return;
            }


            this.curSelectType = selectType;

            let newLeft = 0;
            let newTop = 0;

            if (selectType == "BG") {
                let textBoxRect = this.$refs.textBoxDialog.getBoundingClientRect();

                newLeft = parseFloat(this.$refs.textBoxDialog.style.left) + this.$refs.selectBgColorBtn.offsetLeft;
                newTop = parseFloat(this.$refs.textBoxDialog.style.top) + textBoxRect.height / windowContentScaleY.value;
            } else if (selectType == "FRAME") {
                let textBoxRect = this.$refs.textBoxDialog.getBoundingClientRect();

                newLeft = parseFloat(this.$refs.textBoxDialog.style.left) + this.$refs.selectFrameColorBtn.offsetLeft;
                newTop = parseFloat(this.$refs.textBoxDialog.style.top) + textBoxRect.height / windowContentScaleY.value;
            } else {
                console.error("selectType 錯誤")
            }

            let position = this.limitToView(this.$refs.FrameSelectColor, { x: newLeft, y: newTop });

            this.$refs.FrameSelectColor.style.left = position.x + "px";
            this.$refs.FrameSelectColor.style.top = position.y + "px";

            this.FrameSelectColorShow = true;
        },
        limitToView(target, position) {
            let newPosition = { x: position.x, y: position.y };

            let width = parseFloat(getComputedStyle(target).width);
            let height = parseFloat(getComputedStyle(target).height);

            if (position.x + width > store.baseSize.width) {
                newPosition.x = (store.baseSize.width - width);
            }

            if (position.y + height > store.baseSize.height) {
                newPosition.y = (store.baseSize.height - height)
            }

            return newPosition;
        }
    },
    mounted: function () {
        createFontSizeOption();
        console.log(this);
    }
}

function createFontSizeOption() {
    for (var i = FONT_SIZE_MIN; i <= FONT_SIZE_MAX; i++) {
        var opt = document.createElement("option");
        opt.id = i;
        opt.value = i;
        opt.innerHTML = i;
        fontSizeSelect.appendChild(opt);
    }
}

</script>

<style scoped>
#textBoxDialog {
    position: absolute;
    top: calc(50% - 300px);
    left: calc(50% - 400px);
    background-color: white;
    width: 550px;
    height: 40px;
    border: 3px solid rgb(0, 102, 203);
    border-radius: .5rem;
    justify-content: center;
    align-items: center;
    z-index: var(--z-index-text-box);
}

#textBoxDialog img {
    user-drag: none;
    -webkit-user-drag: none;
    user-select: none;
    -moz-user-select: none;
    -webkit-user-select: none;
    -ms-user-select: none;

}

#textBoxBarTool {
    display: flex;
    justify-content: space-around;
    align-items: center;
    position: relative;
    top: 5px;
}

#fontSizeFrame {
    display: flex;
    justify-content: center;
    align-items: center;
}

.toolImg {
    width: 25px;
    height: 25px;
    position: relative;
    top: 2px;
}

#fontSizeSelect {
    position: relative;
    height: 25px;
}

#fontColorFrame {
    display: flex;
    justify-content: center;
    align-items: center;
    position: relative;

}

#fontColorBtn {
    position: relative;
    top: 0px;
    width: 20px;
    height: 20px;
}

#fontColorBtn>img {
    width: 20px;
    height: 20px;
}

#fontColorView {
    top: -14px;
    position: relative;
    height: 4px;
    width: 21px;
    background-color: black;
}

#selectBgColorBtn {
    display: flex;
    justify-content: space-around;
    align-items: center;
    position: relative;
}

#selectFrameColorBtn {
    display: flex;
    justify-content: space-around;
    align-items: center;
}

#btnDelTextBoxEl {
    position: relative;
}

.setImgSize20 {
    position: relative;
    top: 3px;
    width: 25px;
    height: 25px;
}

#directionDialog {
    position: absolute;
    top: calc(50% - 300px);
    left: calc(50% - 400px);
    background-color: white;
    width: 10em;
    height: auto;
    border: 3px solid rgb(0, 102, 203);
    border-radius: .5rem;
    z-index: var(--z-index-direction-bar);
}

#directionBar {
    height: 3em;
    display: flex;
    justify-content: space-around;
    align-items: center;
}

#directionBar>div {
    width: auto;

}

#directionBar>div>img {
    height: 2em;
}

#directionBar>div>button {
    font-weight: bold;
    font-size: 16px;
    min-width: 60px;
}

#fontSelectColor {
    width: 230px;
    height: 230px;
    background: no-repeat center url("../assets/other_tools/text_box/框01.svg");
    display: flex;
    justify-content: space-evenly;
    position: absolute;
    z-index: var(--z-index-text-box);
}

#fontSelectColor>div {
    display: flex;
    flex-wrap: wrap;
    position: relative;
    top: 5px;
    left: 5px;
}

#FrameSelectColor {
    top: 500px;
    width: 300px;
    height: 100px;
    background: no-repeat center url("../assets/other_tools/text_box/框02.svg");
    position: absolute;
    z-index: var(--z-index-text-box);
}

#FrameSelectColor>div {
    display: flex;
    flex-wrap: wrap;
    justify-content: space-evenly;
    position: relative;
    top: 5px;
}
</style>
